import request from "@/utils/request";

const order = {
    
    gotopUpt: (data) => {//充值订单创建
        return request({
            url: 'order/topUp',
            method: 'POST',
            data
        })
    },
    delOrder: (data) => {//订单删除
        return request({
            url: 'order/delOrder',
            method: 'DELETE',
            data
        })
    },
    getOrderList: (params) => {//订单列表
        return request({
            url: '/order/getOrderList',
            method: 'GET',
            params
        })
    },
    canceOrder: (params) => {//订单取消充值
        return request({
            url: 'order/canceOrder',
            method: 'GET',
            params
        })
    },
    orderPay: (params) => {//支付
        return request({
            url: 'order/orderPay',
            method: 'GET',
            params
        })
    },
    
}
export default order;